import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const Contact = props => (
  <SvgIcon {...props} viewBox="0 0 32 32">
    <path d="M25.122 8.213c1.155 0 2.092 0.928 2.092 2.075v12.231c0 1.146-0.937 2.075-2.092 2.075h-18.816c-1.155 0-2.092-0.928-2.092-2.075v-12.231c0-1.146 0.937-2.075 2.092-2.075h18.816zM13.981 17.58l-7.869-6.178c-0.192-0.151-0.348-0.078-0.348 0.163v10.804c0 0.244 0.199 0.436 0.444 0.436h19.015c0.247 0 0.444-0.195 0.444-0.436v-10.804c0-0.243-0.156-0.314-0.348-0.163l-7.869 6.178c-0.957 0.751-2.509 0.752-3.467 0zM23.859 10.054h-16.289c-0.261 0-0.313 0.13-0.109 0.291l7.694 6.040c0.31 0.244 0.81 0.242 1.118 0l7.694-6.040c0.206-0.162 0.156-0.291-0.109-0.291z" />
  </SvgIcon>
);

export default Contact;
